import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Crons, PriceLimits, ProgramConfig, Site } from '@model';
import { CronService, PriceLimitsService, ProgramService, SiteService } from '@service';

@Injectable()
export class SiteResolver implements Resolve<[Site, Crons, ProgramConfig, PriceLimits]> {
  constructor(
    private siteService: SiteService,
    private programService: ProgramService,
    private cronService: CronService,
    private priceLimitsService: PriceLimitsService,
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<[Site, Crons, ProgramConfig, PriceLimits]> {
    const siteId = route.queryParamMap.get('siteId') || route.paramMap.get('siteId');
    const crons = this.cronService.getCrons(siteId);
    const site = this.siteService.getSite(siteId);
    const programConfig = this.programService.getProgramConfig();
    const priceLimits = this.priceLimitsService.getPriceLimits();
    return forkJoin([of(site), crons, programConfig, priceLimits]).pipe(
      catchError(error => {
        console.log(`the error is `, error);
        return of(error);
      }),
    );
  }
}
